"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.StatsSender = void 0;
var _supports = _interopRequireDefault(require("bloko/common/supports"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// eslint-disable-next-line import/extensions,import/no-unresolved

const TRACKED_NAVIGATION_PERFORMANCE_METRICS = [{
  name: 'preRequest',
  get: timing => timing.domainLookupStart
}, {
  name: 'domainLookup',
  get: timing => timing.domainLookupEnd - timing.domainLookupStart
}, {
  name: 'connect',
  get: timing => timing.connectEnd - timing.connectStart
}, {
  name: 'ttfb',
  get: timing => timing.responseStart - timing.requestStart
}, {
  name: 'download',
  get: timing => timing.responseEnd - timing.responseStart
}];
const getPerformanceTimings = () => {
  const performanceNavigation = window.performance.getEntriesByType('navigation')[0];
  if (!performanceNavigation) {
    return {};
  }
  return Object.fromEntries(TRACKED_NAVIGATION_PERFORMANCE_METRICS.map(metric => [metric.name, metric.get(performanceNavigation)]));
};
class StatsSender {
  /**
   * @param app приложение, отправляющее метрики
   * @param globalParamsGetter функция, возвращающая общие служебные параметры для метрик
   * @param url URL, на который буду отправляться метрики
   * @param beforeSend необязательный коллбэк, вызываемый перед отправкой метрик.
   *                   Должен возвращать true/false, возврат false отменит отправку
   */
  constructor(_ref) {
    let {
      app,
      globalParamsGetter,
      url,
      beforeSend
    } = _ref;
    this._app = app;
    this._url = url;
    this._timings = {};
    this._beforeSend = beforeSend || (() => true);
    this._globalParamsGetter = globalParamsGetter;
  }
  sendMetrics = metricsStat => {
    if (!this._beforeSend(metricsStat)) {
      return;
    }
    window.requestIdleCallback(() => {
      const {
        xsrf,
        ...props
      } = this._globalParamsGetter();
      const baseMetrics = {
        app: this._app,
        mobile: _supports.default.mobile(),
        ...props
      };
      const formData = new FormData();
      const metricsStatArray = Array.isArray(metricsStat) ? metricsStat : [metricsStat];
      metricsStatArray.forEach(metric => {
        formData.append('metrics', JSON.stringify({
          ...baseMetrics,
          ...metric
        }));
      });
      formData.append('_xsrf', xsrf);
      try {
        navigator.sendBeacon(this._url, formData);
      } catch (_) {
        void fetch(this._url, {
          method: 'POST',
          body: formData
        });
      }
    });
  };
  sendNavigationTimings = () => {
    const send = () => {
      // Ждем пока заполнится loadEventEnd
      window.setTimeout(() => {
        const timings = {
          ...getPerformanceTimings(),
          ...this._timings
        };
        this.sendMetrics(Object.keys(timings).map(key => ({
          metricName: `timings.${key}`,
          valueInMs: timings[key]
        })));
      }, 0);
    };
    if (document.readyState === 'complete') {
      send();
    } else {
      window.addEventListener('load', send, {
        once: true
      });
    }
  };
  sendJsExecuted = getJsExecuted => {
    const send = () => {
      this.sendMetrics({
        metricName: 'js-executed',
        count: 1,
        jsExecuted: getJsExecuted(),
        documentState: document.readyState
      });
      window.removeEventListener('load', send);
      window.removeEventListener('beforeunload', send);
    };
    if (document.readyState === 'complete') {
      send();
    } else {
      window.addEventListener('load', send);
      window.addEventListener('beforeunload', send);
    }
  };
  addTimings = additionalTimings => {
    this._timings = {
      ...this._timings,
      ...additionalTimings
    };
    return this;
  };
}
exports.StatsSender = StatsSender;
var _default = exports.default = StatsSender;
//# sourceMappingURL=index.js.map